module.exports = __webpack_public_path__ + "img/packaging_report.be051743.png";